import {ChangeDetectionStrategy, Component, Input, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'fb-upload-file',
  templateUrl: './fb-upload-file.component.html',
  styleUrls: ['./fb-upload-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class FbUploadFileComponent {

  @Output() onFileSelect: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean;
  @Input() fieldName: boolean;
  @Input() statusNote: string;

  validators: any[];
  validatorValue: any;

  validDrag = false;
  invalidDrag = false;

  _files: File[];

  constructor() {}

  get files(): File[] {
    return this._files;
  }

  set files(newFile: File[]) {
    console.log('set files, newFile = ', newFile);
    this.onFileSelect.emit(newFile);
    this._files = [];
  }

}
